import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const SheetIcon = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 3.25H4.5C3.81 3.25 3.25 3.81 3.25 4.5V19.5C3.25 20.19 3.81 20.75 4.5 20.75H19.5C20.19 20.75 20.75 20.19 20.75 19.5V4.5C20.75 3.81 20.19 3.25 19.5 3.25ZM19.25 4.75V6.25H4.75V4.75H19.25ZM4.75 19.25V7.75H19.25V19.25H4.75Z"
      fill={color}
    />
    <path
      d="M16.9989 10.2145L6.99902 10.2529L7.00478 11.7529L17.0047 11.7145L16.9989 10.2145Z"
      fill={color}
    />
    <path d="M17 13.2305H10V14.7305H17V13.2305Z" fill={color} />
  </svg>
);

export default SheetIcon;
